import React from 'react'
import {
    Form,
    Input,
    Radio,
    Space,
    Button, Selector, TextArea, ImageUploader, DatePicker, NavBar, Grid,Image,Toast
} from 'antd-mobile-v5';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../UserAuth/index.css'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    GetPlanetInfo,SaveNNFile,SavePlanetAuthInfo,GetSystemMemorys
} from '../../service/service';
import { environment } from '../../service/baseUrl';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            userInfo: {},
            fileIDList: [],
            fileList: [],

            IDPicture: "",
            DeadCremationImg: "",
        };
    }

    componentDidMount() {
        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            this.setState({
                id: id,
            })

            
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }

    submitForm = () => {
        var that = this;
        // 校验表单字段
        this.formRef.current
            .validateFields()
            .then((values) => {
                if(!this.validateIdCard(values.DeadIDNumber)){
                    Toast.show({
                        icon: 'fail',
                        content: '请输入正确的逝者身份证号！',
                    });
                    return;
                }

                if (this.state.IDPicture == "") {
                    Toast.show({
                        icon: 'fail',
                        content: '请上传管理员身份证！',
                    });
                    return;
                }

                if (this.state.DeadCremationImg == "") {
                    Toast.show({
                        icon: 'fail',
                        content: '请上传逝者火化证原件！',
                    });
                    return;
                }

                // 提交表单数据
                const formData = {
                    ...values,
                    PlanetId: this.state.id,
                    IDPicture: this.state.IDPicture,
                    DeadCremationImg: this.state.DeadCremationImg,
                };

                console.log('提交的表单数据:', formData);

                SavePlanetAuthInfo(formData).then(res => {
                    if (res.success) {
                        if (res.result.id <= 0 || res.result.id == null) {
                            // 显示成功提示
                            Toast.show({
                                icon: 'fail',
                                content: '逝者身份证号重复！',
                            });
                            return;
                        }
                        
                        // 显示成功提示
                        Toast.show({
                            icon: 'success',
                            content: '保存成功！',
                        });

                        setTimeout(() => {
                            that.props.navigate('/formView', { replace: true, state: { id: that.state.id } });
                        }, 2000);

                    } else {
                        Toast.show({
                            icon: 'fail',
                            content: '内部异常！',
                        });
                    }
                })
            })
            .catch((error) => {
                // 校验失败，显示错误提示
                Toast.show({
                    icon: 'fail',
                    content: '请检查表单填写是否正确！',
                });
                console.error('表单校验失败:', error);
            });
    }

    /**
     * 校验身份证号码
     * @param {string} idCard 身份证号码
     * @returns {boolean} 是否有效
     */
    validateIdCard(idCard) {
        // 基本校验
        if (typeof idCard !== 'string') return false;

        // 15位和18位身份证的基本正则
        const reg15 = /^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$/;
        const reg18 = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/;

        // 如果不是15位或18位，直接返回false
        if (!(reg15.test(idCard) || reg18.test(idCard))) {
            return false;
        }

        // 如果是15位，可以转换为18位再校验（可选）
        if (idCard.length === 15) {
            // 15位转18位
            const year = '19' + idCard.substr(6, 2);
            const newIdCard = idCard.substr(0, 6) + year + idCard.substr(6);
            idCard = newIdCard + this.getCheckCode(newIdCard);
        }

        // 18位身份证校验
        if (idCard.length === 18) {
            // 校验出生日期
            const year = parseInt(idCard.substr(6, 4));
            const month = parseInt(idCard.substr(10, 2)) - 1;
            const day = parseInt(idCard.substr(12, 2));
            const birthDate = new Date(year, month, day);

            // 检查日期是否有效
            if (birthDate.getFullYear() !== year ||
                birthDate.getMonth() !== month ||
                birthDate.getDate() !== day) {
                return false;
            }

            // 检查校验码
            const checkCode = this.getCheckCode(idCard.substr(0, 17));
            if (checkCode.toUpperCase() !== idCard.charAt(17).toUpperCase()) {
                return false;
            }
        }

        return true;
    }

    /**
     * 获取身份证校验码
     * @param {string} idCardBase 身份证前17位
     * @returns {string} 校验码
     */
    getCheckCode(idCardBase) {
        // 加权因子
        const weightFactors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        // 校验码对应值
        const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

        let sum = 0;
        for (let i = 0; i < 17; i++) {
            sum += parseInt(idCardBase.charAt(i)) * weightFactors[i];
        }

        const mod = sum % 11;
        return checkCodes[mod];
    }
  


    render() {


        return (
            <div style={{ width: "100%", height: "100%" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/formView', { replace: true, state: { id: this.state.id } }); // 传递状态
                }}>
                    认证唯一性
                </NavBar>

                <div className="userAuth" style={{
                    height: "85%", backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/2-08.png')"
                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", paddingTop: "5%"
                }}>

                    <div style={{ width: "92%", backgroundColor: "#fff", marginLeft: "4%", borderRadius: "2%" }}>



                        <Form
                            name='form'
                            ref={this.formRef}
                            // layout='horizontal'
                            footer={
                                <div>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                        , fontWeight: "600", color: "#fff"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        提 交
                            </div>
                                </div>
                            } style={{ borderRadius: "2%" }}
                        >


                            <Form.Item
                                name='Name'
                                label='管理员真实姓名'
                                rules={[{ required: true, message: '管理员真实姓名不能为空' }]}
                            >
                                <Input onChange={console.log} placeholder='请输入管理员真实姓名' />
                            </Form.Item>


                            {/* <Form.Item
                                name='IDPicture'
                                label='管理员身份证'
                            >
                                <ImageUploader
                                    columns={2}
                                    maxCount={2}
                                    // style={{ '--cell-size': '90px' }}
                                    defaultValue={this.state.fileList}
                                    onChange={(file) => {
                                        this.setState({
                                            fileList: file
                                        })
                                    }}
                                    deleteIcon={
                                        <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                            width={14} height={14} />
                                    }
                                    upload={(file) => {
                                        return {
                                            url: URL.createObjectURL(file),
                                        }
                                    }}
                                    children={
                                        <Image src={"https://api.weibinyi.com/images/niannian/1/4-10.png"} fit='fill'
                                            width={130} height={100} />
                                    }
                                />
                            </Form.Item> */}

                            <div>
                                <div style={{
                                    marginLeft: "7%", marginBottom: "10px", fontSize: "0.373333rem", paddingTop: "3%",
                                    fontWeight: "600", color: "var(--adm-color-text-secondary)", borderTop: "var(--border-inner)"
                                }}>
                                    管理员身份证
                                    </div>

                                <div style={{ marginLeft: "4%", marginRight: "4%", marginBottom: "3%" }}>

                                    <ImageUploader
                                        columns={2}
                                        maxCount={1}
                                        style={{ '--cell-size': '40px' }}
                                        value={this.state.fileIDList || []}
                                        defaultValue={this.state.fileIDList || []}
                                        beforeUpload={async (file) => {
                                            console.log('BeforeUpload - 文件信息:', file);
                                            if (!(file instanceof File)) {
                                                Toast.show({ icon: 'fail', content: '无效的文件！' });
                                                return false;
                                            }
                                            if (file.size > 5 * 1024 * 1024) {
                                                Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                                return false;
                                            }

                                            var res = await GetSystemMemorys(this.state.id);
                                            if (res.success) {
                                                var count = 0;
                                                res.result.map(item => {
                                                    count += item.fileSize;
                                                })
                                                var maxSize = 300;
                                                var models = this.state.userInfo.planetSizes
                                                    .filter(x => x.planetId == this.state.id);
                                                if (models != null && models.length > 0) {
                                                    maxSize = models[0].fileSumSize;
                                                }
                                                if (count > maxSize) {
                                                    Toast.show({ content: '该星球文件空间已满！' });
                                                    return false;
                                                }
                                            }
                                            const fileCopy = new File([file], file.name, { type: file.type });
                                            return fileCopy;
                                        }}
                                        onChange={(fileList) => {
                                            console.log('OnChange - 文件列表:', fileList);
                                            this.setState({ fileIDList: fileList });
                                        }}
                                        upload={async (file) => {
                                            try {
                                                console.log('Upload - 开始上传:', file);

                                                // 1. 验证文件对象
                                                if (!(file instanceof File)) {
                                                    throw new Error('无效的文件对象');
                                                }

                                                // 2. 创建临时预览URL
                                                const tempUrl = URL.createObjectURL(file);
                                                console.log('临时预览URL创建成功:', tempUrl);

                                                // 3. 上传文件
                                                const formData = new FormData();
                                                formData.append('file', file);
                                                formData.append('userid', this.state.userInfo.id);
                                                formData.append('scoureName', "Img");
                                                formData.append('planetId', this.state.id);

                                                const response = await SaveNNFile(formData);
                                                console.log('上传响应:', response);

                                                // 4. 确保返回正确的URL格式
                                                let imageUrl;
                                                if (typeof response === 'string') {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else if (response.result) {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else {
                                                    throw new Error('无效的服务器响应');
                                                }

                                                this.setState({
                                                    IDPicture: response.result
                                                })
                                                // 5. 释放临时URL
                                                URL.revokeObjectURL(tempUrl);

                                                return {
                                                    url: imageUrl
                                                };
                                            } catch (error) {
                                                console.error('上传过程出错:', error);
                                                Toast.show({ icon: 'fail', content: '上传失败' });
                                                throw error;
                                            }
                                        }}
                                        deleteIcon={
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                                width={14} height={14} />
                                        }
                                        children={
                                            <Image src={"https://api.weibinyi.com/images/niannian/1/4-10.png"} fit='fill'
                                                width={130} height={100} />
                                        }
                                    />

                                </div>
                            </div>


                            <Form.Item
                                name='DeadIDNumber'
                                label='逝者身份证号'
                                rules={[{ required: true, message: '逝者身份证号不能为空' }]}
                            >
                                <Input onChange={console.log} placeholder='请输入逝者身份证号' />
                            </Form.Item>


                            {/* <Form.Item
                                name='DeadCremationImg'
                                label='逝者火化证原件'
                            >
                                <ImageUploader
                                    columns={2}
                                    maxCount={1}
                                    // style={{ '--cell-size': '90px' }}
                                    defaultValue={this.state.fileList}
                                    onChange={(file) => {
                                        this.setState({
                                            fileList: file
                                        })
                                    }}
                                    deleteIcon={
                                        <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                            width={14} height={14} />
                                    }
                                    upload={(file) => {
                                        return {
                                            url: URL.createObjectURL(file),
                                        }
                                    }}
                                    children={
                                        <Image src={"https://api.weibinyi.com/images/niannian/1/4-10.png"} fit='fill'
                                            width={130} height={100} />
                                    }
                                />
                            </Form.Item> */}

                            <div>
                                <div style={{
                                    marginLeft: "7%", marginBottom: "10px", fontSize: "0.373333rem", paddingTop: "3%",
                                    fontWeight: "600", color: "var(--adm-color-text-secondary)", borderTop: "var(--border-inner)"
                                }}>
                                    逝者火化证原件
                                    </div>

                                <div style={{ marginLeft: "4%", marginRight: "4%", marginBottom: "3%" }}>

                                    <ImageUploader
                                        columns={2}
                                        maxCount={1}
                                        style={{ '--cell-size': '40px' }}
                                        value={this.state.fileList || []}
                                        defaultValue={this.state.fileList || []}
                                        beforeUpload={async (file) => {
                                            console.log('BeforeUpload - 文件信息:', file);
                                            if (!(file instanceof File)) {
                                                Toast.show({ icon: 'fail', content: '无效的文件！' });
                                                return false;
                                            }
                                            if (file.size > 5 * 1024 * 1024) {
                                                Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                                return false;
                                            }

                                            var res = await GetSystemMemorys(this.state.id);
                                            if (res.success) {
                                                var count = 0;
                                                res.result.map(item => {
                                                    count += item.fileSize;
                                                })
                                                var maxSize = 300;
                                                var models = this.state.userInfo.planetSizes
                                                    .filter(x => x.planetId == this.state.id);
                                                if (models != null && models.length > 0) {
                                                    maxSize = models[0].fileSumSize;
                                                }
                                                if (count > maxSize) {
                                                    Toast.show({ content: '该星球文件空间已满！' });
                                                    return false;
                                                }
                                            }
                                            const fileCopy = new File([file], file.name, { type: file.type });
                                            return fileCopy;
                                        }}
                                        onChange={(fileList) => {
                                            console.log('OnChange - 文件列表:', fileList);
                                            this.setState({ fileList });
                                        }}
                                        upload={async (file) => {
                                            try {
                                                console.log('Upload - 开始上传:', file);

                                                // 1. 验证文件对象
                                                if (!(file instanceof File)) {
                                                    throw new Error('无效的文件对象');
                                                }

                                                // 2. 创建临时预览URL
                                                const tempUrl = URL.createObjectURL(file);
                                                console.log('临时预览URL创建成功:', tempUrl);

                                                // 3. 上传文件
                                                const formData = new FormData();
                                                formData.append('file', file);
                                                formData.append('userid', this.state.userInfo.id);
                                                formData.append('scoureName', "Img");
                                                formData.append('planetId', this.state.id);

                                                const response = await SaveNNFile(formData);
                                                console.log('上传响应:', response);

                                                // 4. 确保返回正确的URL格式
                                                let imageUrl;
                                                if (typeof response === 'string') {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else if (response.result) {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else {
                                                    throw new Error('无效的服务器响应');
                                                }

                                                this.setState({
                                                    DeadCremationImg: response.result
                                                })
                                                // 5. 释放临时URL
                                                URL.revokeObjectURL(tempUrl);

                                                return {
                                                    url: imageUrl
                                                };
                                            } catch (error) {
                                                console.error('上传过程出错:', error);
                                                Toast.show({ icon: 'fail', content: '上传失败' });
                                                throw error;
                                            }
                                        }}
                                        deleteIcon={
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                                width={14} height={14} />
                                        }
                                        children={
                                            <Image src={"https://api.weibinyi.com/images/niannian/1/4-10.png"} fit='fill'
                                                width={130} height={100} />
                                        }
                                    />

                                </div>
                            </div>



                        </Form>




                        <div style={{ marginRight: "5%", color: "#989898", paddingBottom: "5%" }}>
                            <Grid columns={6} gap={8}>
                                <Grid.Item span={1} style={{ textAlign: "end", fontWeight: "900", color: "#000" }}>
                                    告知
                        </Grid.Item>
                                <Grid.Item span={5}>
                                    <div>1、请确保上传资料的真实有效；</div>
                                    {/* <div>2、认证完毕后，念念星辰就不再接受相同姓名、出生日期和过世日期的逝者提交的创建申请。有相同的星星也会将其屏蔽。</div> */}
                                    <div>2、认证完毕后，念念星辰就不再接受相同逝者身份证号的逝者家属提交的创建申请。有相同的星星也会将其屏蔽。</div>
                                </Grid.Item>
                            </Grid>

                        </div>
                    </div>

                </div>



                <BottomMenu position="fixed" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);